import Http from '@/classes/http/Http'

export default {
  getCustomerProfile: function () {
    return Http.get({
      url: 'profile'
    })
  },
  getFiles (customerId) {
    return Http.get({
      url: `customers/${customerId}/files`
    })
  }
}
